/*
 * Copyright (c) 2018.  Bakos Energy (Apeldoorn NL), Spin in het Web (Apeldoorn NL)
 */

/**
 * SPIN IN HET WEB APELDOORN
 * User: Jelmer Jellema
 * Date: 5-3-2018
 * Time: 12:32
 *
 */

angular.module('sihw.memcache', ['sihw.angular.config', 'sihw.sihwlog', 'sihw.thenloops'])
    .factory('sihwmemcache', ['$q', 'sihwAngularConfig', 'sihwlog', 'thenEach', function ($q, sihwAngularConfig, sihwlog, thenEach) {
        let log = sihwlog.logLevel(sihwAngularConfig.loglevel('sihwmemcache'));
        log.debug('sihwmemcache startup');

        //sihw-angular-opties
        let config = sihwAngularConfig.opties('sihwmemcache');

        let cache = new Map();
        let currentSize = 0; //bytegrootte
        let deleteOn = new Map();
        let maxSize = config.maxSize || 10 * 1024 * 1024; //default 10MB

        log.debug(`sihwmemcache maxSize: ${maxSize / (1024 * 1024)} MB`);

        ////////////////////// INTERNE FUNCTIES //////////////////////////////////////////////


        /**
         * Geef de data in de cache terug, of null als het er niet is (geen reject dan)
         * @param {string | Object} cacheKey
         * @param {string[]} [deleteOnKeys] optionele array met extra deleteOn-opties, zie addCache
         * @returns * undefined als niet gevonden
         */
        function getCache(cacheKey, deleteOnKeys) {
            //cacheKey is een string of een object dat als cache moet dienen, we hashen het dus altijd even
            let cacheKeyHash = objectHash.sha1(cacheKey);
            log.debug('getCache', cacheKeyHash);
            if (cache.has(cacheKeyHash)) {

                let cached = cache.get(cacheKeyHash); //dit is een map met properties en data
                log.debug('CacheHit voor key', cacheKeyHash, cached);
                cached.set('lasthit', Date.now());

                if (deleteOnKeys && deleteOnKeys.length) {
                    //nieuwe deleteOnKeys toevoegen
                    //deleteOn is op keys
                    for (let key of deleteOnKeys) {
                        if (cached.get('deleteOn').has(key)) {
                            continue; //deze kennen we al
                        }
                        let dkeys;
                        if (deleteOn.has(key)) {
                            dkeys = deleteOn.get(key);
                        }
                        else {
                            dkeys = new Set();
                            deleteOn.set(key, dkeys);
                        }
                        //dkeys moet dus nu de cacheKeyHash erbij hebben
                        dkeys.add(cacheKeyHash);
                        //en we houden in de cached map ook een link naar deze dkeys-set
                        //zodat we snel kunnen verwijderen als de cachekey eraan gaat
                        cached.get('deleteOn').set(key, dkeys);
                    }
                }
                return angular.copy(cached.get('data')); //en geef terug
            }
            else {
                return undefined; //niet gevonden
            }
        }

        /**
         * Clear en reinit de cache
         * @private
         * @returns void
         */
        function clearCache() {
            log.debug('sihwcache: clearcache');
            cache.clear();
            deleteOn.clear();
            currentSize = 0;
        }

        /**
         * Clear delen van de cache gegeven een wijzigingsevent.
         * @param {String|String[]} deleteOnKeys de key(s) die de wijziging beschrijft / beschrijven
         * returns void
         */
        function clearCacheOn(deleteOnKeys) {
            //bepaalde deleteOnKeys vuren in de applicatie. We gaan kijken welke weg moeten

            if (!Array.isArray(deleteOnKeys)) {
                deleteOnKeys = [deleteOnKeys];
            }
            else {
                deleteOnKeys = angular.copy(deleteOnKeys); //altijd een kopie, want we voegen toen
            }
            deleteOnKeys.push('*'); //namelijk de 'altijd wissen'

            log.debug('clearCacheOn', deleteOnKeys);
            let verwijderen = new Set();
            for (let key of deleteOnKeys) {
                if (deleteOn.has(key)) {
                    //geen iterator op sets, maar forEach, ivm ie 11...
                    deleteOn.get(key).forEach(cacheKeyHash => {
                        verwijderen.add(cacheKeyHash);
                    });
                }
            }
            //en nu pas keurig stuk voor stuk verwijderen, ook ivm de size
            verwijderen.forEach(cacheKeyHash => {
                deleteCacheHash(cacheKeyHash); //al op hash-niveau
            });
        }

        /**
         * Voeg toe aan de cache
         * @param {String|Object} cacheKey
         * @param {Array} deleteOnKeys
         * @param {*} data
         * @returns void
         */
        function addCache(cacheKey, deleteOnKeys, data) {
            let vooraf = Date.now();
            let cacheKeyHash = objectHash.sha1(cacheKey); //maak een hash van de key of het object
            if (cache.has(cacheKeyHash)) {
                deleteCacheHash(cacheKeyHash); //eerst weg, ivm size
            }
            let size = sizeof(data); //gok van de size
            log.debug(`sihwmemcache: addCache ${cacheKeyHash} size ${size}`);
            currentSize += size;
            if (currentSize > maxSize) {
                opruimen(); //zorg dat we weer onder de maxSize zitten
            }

            data = angular.copy(data); //altijd een kopie

            let cached = new Map;
            cached.set('data', data);
            cached.set('deleteOn', new Map());
            cached.set('size', size);
            cached.set('key', cacheKeyHash); //ook hier bewaren
            cached.set('lasthit', Date.now()); //toevoegen telt ook als hit

            //de deleteOnKeys
            if (deleteOnKeys && deleteOnKeys.length) {
                //nieuwe deleteOnKeys toevoegen
                //deleteOn is op keys
                for (let key of deleteOnKeys) {
                    if (cached.get('deleteOn').has(key)) {
                        continue; //deze kennen we al (dubbel in de keys?)
                    }
                    let dkeys;
                    if (deleteOn.has(key)) {
                        dkeys = deleteOn.get(key);
                    }
                    else {
                        dkeys = new Set();
                        deleteOn.set(key, dkeys);
                    }
                    //dkeys moet dus nu de cacheKeyHash erbij hebben
                    dkeys.add(cacheKeyHash);
                    //en we houden in de cached map ook een link naar deze dkeys-set
                    //zodat we snel kunnen verwijderen als de cachekey eraan gaat
                    cached.get('deleteOn').set(key, dkeys);
                }
            }
            //en toevoegen
            cache.set(cacheKeyHash, cached);
            log.debug(`Cache is nu ${currentSize} ${Math.round((currentSize / maxSize) * 100)}%`);
            log.debug(`Toevoegen aan cache ${Date.now() - vooraf} ms`);
        }

        /**
         * Helper: geef een schatting van de byte-grootte van een stuk data terug
         * Dit is een heel ruwe schatting: wat we doen bij een array is max 10 elementen nemen en dan extrapoleren!
         * @param data
         */
        function sizeof(data) {
            let size = 0;
            let todo = [data];
            let done = new Set();

            while (todo.length) {
                let o = todo.shift();
                if (done.has(o)) {
                    continue; //kennen we al
                }
                if (o === null || o === undefined) {
                    //4byte pointer?
                    size += 4;
                    continue;
                }

                switch (typeof(o)) {
                    case 'boolean':
                        size += 4;  //volgends de specs
                        break;
                    case 'number':
                        size += 8; //volgens de specs
                        break;
                    case 'string':
                        size += 2 * o.length; //16-bits
                        break;
                    case 'object':
                        //toevoegen aan done
                        done.add(o);
                        //is dit een array? Dan pakken we maximaal x items en extrapoleren we het resultaat voor de snelheid
                        if (Array.isArray(o)) {
                            done.add(o);
                            const deelgrootte = 25; //steekproefgrootte
                            if (o.length <= deelgrootte) {
                                todo.push(...o); //gewoon allemaal apart
                            }
                            else {
                                let stap = Math.floor(o.length / deelgrootte);
                                let deelsize = 0;
                                for(let i = 0; i < deelgrootte; i++)
                                {
                                    deelsize += sizeof(o[i * stap]); //leuk verdeeld
                                }
                                log.debug(`Size van deel ${deelgrootte} van de ${o.length}: ${deelsize}`);
                                let totaalsize = deelsize * (o.length / deelgrootte);
                                log.debug(`Totaalsize dus ${deelsize} * (${o.length} / ${deelgrootte}) = ${deelsize} * ${o.length / deelgrootte} =  ${totaalsize}`);
                                //size += Math.ceil(sizeof(o.splice(0, deelgrootte - 1)) * (o.length / deelgrootte));
                                size+= Math.ceil(totaalsize);
                            }
                        }
                        else {
                            //object
                            //dan tellen de keys ook mee me de grootte
                            size += Object.keys(o).reduce((tot,k) => tot + 2 * k.length,0); //16bit-string
                            todo.push(...Object.values(o));
                        }
                        break;
                    default:
                        log.warn(`sihwcache sizeof - vreemd type ${typeof(o)}`);
                        break;
                }
            }
            return size;
        }

        /**
         * Verwijder een key uit de cache
         * @param cacheKey Nog niet gehashede key
         * @returns void
         */
        function deleteCache(cacheKey) {
            deleteCacheHash(objectHash.sha1(cacheKey));
        }

        /**
         * Verwijder een key uit de cache
         * @param cacheKeyHash Al gehashede key
         * @returns  void
         */
        function deleteCacheHash(cacheKeyHash) {
            log.debug('deleteCacheHash', cacheKeyHash);
            if (!cache.has(cacheKeyHash)) {
                log.debug('deleteCacheHash: key niet gevonden');
                return; //klaar
            }
            let cached = cache.get(cacheKeyHash);
            cache.delete(cacheKeyHash);
            log.debug('Dit gaat weg', cached);
            currentSize -= cached.get('size');
            //in cached hebben we deleteOn. De values zijn rechtstreekse objectrefs naar de deleteOn sets, dus daar kunnen
            //we de key gewoon uithalen, zonder zoeken
            //foreach ipv for-loop ivm ie 11...
            cached.get('deleteOn').forEach(keys => {
                keys.delete(cacheKeyHash); //deze er dus uit
            });
            log.debug(`Cache is nu ${currentSize} ${Math.round((currentSize / maxSize) * 100)}%`);
        }

        /**
         * Ruim op tot we weer onder maxSize zitten
         * We hebben niet een erg efficiënte manier van laatste hit, maar gaan ervan uit dat opruimen niet heel vaak nodig is
         */
        function opruimen() {
            log.debug(`Cache voor opruimen ${currentSize} ${maxSize} ${cache.size} ${Math.round((currentSize / maxSize) * 100)}%`);
            while ((currentSize > maxSize) && cache.size > 0) {
                log.debug('in buitenstste opruimloop');
                let oudste = null;
                cache.forEach(cached => {
                    if ((!oudste) || cached.get('lasthit') < oudste.get('lasthit')) {
                        log.debug('opruimen, nieuwe oudste');
                        oudste = cached;
                    }
                });
                if (oudste) {
                    log.debug('Dit is de oudste, die gaat weg', oudste);
                    deleteCacheHash(oudste.get('key'));
                }
            }
            log.debug(`Cache na opruimen ${currentSize} ${Math.round((currentSize / maxSize) * 100)}%`);
        }


        ////////////// SERVICE //////////////////////
        return {

            /**
             * Geef data in de dache terug, of null als het er niet is (geen reject dan).
             * @param {string | Object} cacheKey
             * @param {string[]} [deleteOnKeys] optionele array met extra deleteOn-opties, zie addCache
             * @returns * of undefined als er niets in de cache zit
             */
            get(cacheKey, deleteOnKeys) {
                return getCache(cacheKey, deleteOnKeys);
            },

            /**
             * Voeg toe aan de cache
             * @param {String|Object} cacheKey
             * @param {Array} deleteOnKeys
             * @param {*} data
             * @returns void
             */
            add(cacheKey, deleteOnKeys, data) {
                addCache(cacheKey, deleteOnKeys, data);
            },
            /**
             * Verwijder een key uit de cache
             * @param {string|Object} cacheKey
             * @returns $void
             */
            delete(cacheKey) {
                deleteCache(cacheKey); //ruwe sleutel
            },
            /**
             * Leeg de cache
             */
            clear() {
                return clearCache();
            },

            /**
             * Clear delen van de cache gegeven een wijzigingsevent. Roep zoveel mogelijk in 1 keer aan met alle keys, ivm locking
             * @param {String|String[]} deleteOnKeys de key(s) die de wijziging beschrijven
             * @returns void
             */
            clearOn(deleteOnKeys) {
                clearCacheOn(deleteOnKeys);
            }
        };
    }]);
